import request from '@/utils/request'
import {getCookie, setCookie} from '@/utils/cookie'
import {Message, Loading} from 'element-ui'
import SnowflakeId from 'snowflake-id'
import vue from '../main'

// 注册监听页面失去焦点事件
window.onblur = function () {
  vue.eventBus.$emit("pageLoseFocus")
};

// 当前环境是否是生产环境
let isProductEnv = process.env.NODE_ENV === '"production"';
// 刷新系统消息  true_开启 false_关闭
let refreshSystemMessages = true;
// console.log(getCookie('refreshSystemMessages'))
// 表单是否开启验证
let openFormValidate = true;
// 后台接口上下文
const serviceContext = process.env.VUE_APP_BASE_API;

// 获取当前网站网址 如：https://test-dingdan.kerida.cn，如果端口为443则去掉端口
function getWebsiteUrl() {
  if (location.port === "443" || location.port === "80" || location.port === "") {
    return location.protocol + "//" + location.hostname
  } else {
    return location.protocol + "//" + location.hostname + ":" + location.port
  }
}

function getUrlBasicPrefix() {
  let urlBasicPrefix; // 网站URL

  let urlProtocol; // 网站协议
  if (process.env.NODE_ENV === 'production') {
    urlProtocol = "https://"   // 测试打包换成http:// 正式打包换成https://
  } else {
    urlProtocol = "http://"
  }

  if (!!location.port) {
    urlBasicPrefix = urlProtocol + location.hostname + ":" + location.port + "/" + serviceContext
  } else {
    urlBasicPrefix = urlProtocol + location.hostname + "/" + serviceContext
  }

  return urlBasicPrefix
}

// 网站基础前缀
const urlBasicPrefix = getUrlBasicPrefix();
// 网站前缀
const urlPrefix = urlBasicPrefix;
// 网站图片前缀
//const imgUrlPrefix = urlBasicPrefix + '/dynamic';
const imgUrlPrefix = urlBasicPrefix;
// 后台样式文件路径
const cssPath = urlPrefix + '/themes';
// 银行接口URL前缀
const bank_api_url_prefix = "https://test-dingdan.zcxsd.cn";

const page = 1; //当前页码
const limit = 20; //每页上数据的条数

const cropperWidth = 720; //图片裁剪画布高度
const cropperHeight = 480; //图片裁剪画布宽度

const imgMaxWidth = 218; //缩略图最大宽度
const imgMaxHeight = 124; //缩略图最大高度

let snowflake = new SnowflakeId({
  mid: 42,
  offset: (2019 - 1970) * 31536000 * 1000
});
const snowflakeId = parseInt(snowflake.generate(), 10).toString(36);


/**
 * @param name 接口名称
 * @param url  接口URL
 * @param params 接口参数
 * @param isLoading  是否显示Loading（默认为false）
 * @param errorShowDiy  错误信息自定义显示（默认为false，若为true则不显示顶部提示消息）
 * @returns {Q.Promise<Promise<never>> | Function | any | Promise<any> | undefined}
 */
/**
 * @param name 接口名称
 * @param url  接口URL
 * @param params 接口参数
 * @param isLoading  是否显示Loading（默认为false）
 * @param errorShowDiy  错误信息自定义显示（默认为false，若为true则不显示顶部提示消息）
 * @returns {Q.Promise<Promise<never>> | Function | any | Promise<any> | undefined}
 */
function httpGet(name, url, params, isLoading, errorShowDiy) {
  let loadingInstance = null;
  let loadingTimeout = null;
  // 如果请求处理时间超过1秒钟，则开启遮罩
  if (!isLoading) {
    loadingTimeout = setTimeout(() => {
      loadingInstance = Loading.service({lock: true}); //开启遮罩
    }, 1000);
  }

  return request({name: name, url: url, method: 'get', params: params, errorShowDiy: errorShowDiy}).then(res => {
    if (!isLoading && loadingInstance !== null) {
      loadingInstance.close(); //关闭遮罩
    }

    if (loadingTimeout != null) {
      clearTimeout(loadingTimeout);
    }

    return res
  }).catch(error => {
    if (!isLoading && loadingInstance !== null) {
      loadingInstance.close() //关闭遮罩
    }

    if (loadingTimeout != null) {
      clearTimeout(loadingTimeout);
    }

    if (errorShowDiy) {
      console.debug(name + '接口请求时发生错误，原因：' + error);
      vue.eventBus.$emit('showErrorInfo', error)
    } else {
      console.debug(name + '接口请求时发生错误，原因：' + error);
      Message({
        message: error,
        type: 'error',
        duration: 5 * 1000
      })
    }

    return Promise.reject(error)
  })
}

function httpPost(name, url, params, isLoading, errorShowDiy) {
  let loadingInstance = null;
  let loadingTimeout = null;
  // 如果请求处理时间超过1秒钟，则开启遮罩
  if (!isLoading) {
    loadingTimeout = setTimeout(() => {
      loadingInstance = Loading.service({lock: true}); //开启遮罩
    }, 1000);
  }


  return request({name: name, url: url, method: 'post', data: params, errorShowDiy: errorShowDiy}).then(res => {
    if (!isLoading && loadingInstance !== null) {
      loadingInstance.close(); //关闭遮罩
    }

    if (loadingTimeout != null) {
      clearTimeout(loadingTimeout);
    }

    return res
  }).catch(error => {
    if (!isLoading && loadingInstance !== null) {
      loadingInstance.close() //关闭遮罩
    }

    if (loadingTimeout != null) {
      clearTimeout(loadingTimeout);
    }

    if (errorShowDiy) {
      console.debug(name + '接口请求时发生错误，原因：' + error);
      vue.eventBus.$emit('showErrorInfo', error)
    } else {
      console.debug(name + '接口请求时发生错误，原因：' + error);
      Message({
        message: error,
        type: 'error',
        duration: 5 * 1000
      })
    }

    return Promise.reject(error)
  })
}

function getVerifySid() {
  return uuidGenerator() + uuidGenerator().substring(0, 8)
}

function uuidGenerator() {
  let originStr = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
    originChar = '0123456789abcdef',
    len = originChar.length;
  return originStr.replace(/x/g, function (match) {
    return originChar.charAt(Math.floor(Math.random() * len))
  })
}

export default {
  urlBasicPrefix,
  urlPrefix,
  imgUrlPrefix,
  cssPath,
  page,
  limit,
  imgMaxWidth,
  imgMaxHeight,
  cropperWidth,
  cropperHeight,
  httpPost,
  httpGet,
  snowflakeId,
  openFormValidate,
  refreshSystemMessages,
  getWebsiteUrl,
  isProductEnv,
  bank_api_url_prefix,
  getVerifySid
}



// WEBPACK FOOTER //
// ./src/utils/common.js